/**
 * 生成Mock 的进度条
 */
interface IOptions {
  minimum: number;
  onProgress: (val: number) => void;
}

export class MockProgress {
  private speed = 25; // 进度条更新耗时
  private progress: number;
  private minimum: number; // 最小粒度
  private timer: any;
  private onProgress: any;

  constructor(options: Partial<IOptions>) {
    this.timer = null;
    this.progress = 0;
    this.onProgress = options?.onProgress;
    this.minimum = options.minimum || 1;
  }

  set(progress: number, duration?: number) {
    const progressVal = progress >= 99 ? 99 : progress;
    this._updateProgress(progressVal, duration);
  }

  done() {
    this.progress = 100;
    this.onProgress?.(100);
  }

  private _updateProgress = (maxProgress: number, duration?: number) => {
    const gapProgress = maxProgress - this.progress;
    let currentSpeed = this.speed;
    if (duration) {
      currentSpeed = duration / (gapProgress * this.minimum);
      currentSpeed = currentSpeed > 200 ? 200 : currentSpeed;
    }

    this.timer = setTimeout(() => {
      this.progress = this.progress + this.minimum;
      if (this.progress >= 99) {
        this.progress = 99;
        clearTimeout(this.timer);
        return;
      }

      this.onProgress?.(this.progress);

      if (this.timer && this.progress >= maxProgress) {
        clearTimeout(this.timer);
      } else {
        this._updateProgress(maxProgress, duration);
      }
    }, currentSpeed);
  };
}
